import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
  <div
    className="background-main-color"
    style={{
      marginBottom: '1.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
        >
          Libros de emprendimiento
        </Link>
      </h1>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js